import classNames from "classnames";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";

import {iconPosition, iconPositionMobile, iconPositionRight} from "./SliderGalleryIcon.module.css";

interface IProps {
    enableOnMobile?: boolean;
    fill?: string;
    height?: number;
    iconSize?: string;
    iconWrapperSize?: string;
    position: "left" | "right";
    width?: number;
    wrapperColor: string;
}

const DEFAULT_ICON_SIZE = "2.4";
const DEFAULT_ICON_WRAPPER_SIZE = "4.8";
const DEFAULT_PIXEL_ICON_WRAPPER_SIZE = "2.4";

export const SliderGalleryIcon = (props: IProps) => {
    const {enableOnMobile, fill, height, iconSize, iconWrapperSize, position, width, wrapperColor} = props;

    const hasPixelSize = width !== undefined || height !== undefined;
    const iconPositionStyle = position === "right" && iconPositionRight;
    const mobileDisplay = enableOnMobile ? {display: "block"} : {display: "none"};
    const iconPositionCN = classNames(iconPosition, iconPositionStyle, mobileDisplay, iconPositionMobile);
    const ChevronIcon = position === "left" ? ChevronLeftIcon : ChevronRightIcon;

    const iconProps = hasPixelSize
        ? {
              fill,
              height,
              width,
              wrapperColor,
              wrapperSize: iconWrapperSize || DEFAULT_PIXEL_ICON_WRAPPER_SIZE
          }
        : {
              fill,
              size: iconSize || DEFAULT_ICON_SIZE,
              wrapperColor,
              wrapperSize: iconWrapperSize || DEFAULT_ICON_WRAPPER_SIZE
          };

    return (
        <div className={iconPositionCN}>
            <ChevronIcon {...iconProps} />
        </div>
    );
};
import classNames from "classnames";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";

import {iconPosition, iconPositionMobile, iconPositionRight} from "./SliderGalleryIcon.module.css";

interface IProps {
    enableOnMobile?: boolean;
    fill?: string;
    height?: number;
    iconSize?: string;
    iconWrapperSize?: string;
    position: "left" | "right";
    width?: number;
    wrapperColor: string;
}

const DEFAULT_ICON_SIZE = "2.4";
const DEFAULT_ICON_WRAPPER_SIZE = "4.8";
const DEFAULT_PIXEL_ICON_WRAPPER_SIZE = "2.4";

export const SliderGalleryIcon = (props: IProps) => {
    const {enableOnMobile, fill, height, iconSize, iconWrapperSize, position, width, wrapperColor} = props;

    const hasPixelSize = width !== undefined || height !== undefined;
    const iconPositionStyle = position === "right" && iconPositionRight;
    const mobileDisplay = enableOnMobile ? {display: "block"} : {display: "none"};
    const iconPositionCN = classNames(iconPosition, iconPositionStyle, mobileDisplay, iconPositionMobile);
    const ChevronIcon = position === "left" ? ChevronLeftIcon : ChevronRightIcon;

    const iconProps = hasPixelSize
        ? {
              fill,
              height,
              width,
              wrapperColor,
              wrapperSize: iconWrapperSize || DEFAULT_PIXEL_ICON_WRAPPER_SIZE
          }
        : {
              fill,
              size: iconSize || DEFAULT_ICON_SIZE,
              wrapperColor,
              wrapperSize: iconWrapperSize || DEFAULT_ICON_WRAPPER_SIZE
          };

    return (
        <div className={iconPositionCN}>
            <ChevronIcon {...iconProps} />
        </div>
    );
};
